<template>
  <div>
    <v-dialog
      v-model="ModalEdit"
      persistent
      scrollable
      max-width="1000px"
      content-class="edit-jabatan-dialog"
    >
      <v-card class="edit-jabatan-modal" flat>
        <!-- Loading -->
        <div v-if="refpelaksana.length === 0">
          <v-skeleton-loader type="card, article" />
        </div>

        <template v-else>
          <!-- HEADER -->
          <div class="edit-modal-header">
            <div class="edit-header-content">
              <div class="edit-header-icon">
                <v-icon size="28" color="white">
                  mdi-briefcase-edit-outline
                </v-icon>
              </div>

              <div class="edit-header-text">
                <div class="edit-header-eyebrow">MANAJEMEN KEPEGAWAIAN</div>

                <h2>Edit Data Jabatan</h2>

                <p>Perbarui informasi jabatan dan struktur organisasi.</p>
              </div>
            </div>

            <v-btn
              icon
              dark
              class="edit-header-close"
              aria-label="Tutup modal"
              @click="closeModal"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <!-- BODY -->
          <v-card-text class="edit-modal-body">
            <!-- ATASAN LANGSUNG -->
            <section class="edit-section">
              <div class="edit-section-heading">
                <div class="edit-section-icon parent-icon">
                  <v-icon>mdi-account-supervisor-outline</v-icon>
                </div>

                <div>
                  <h3>Struktur Organisasi</h3>
                  <p>Tentukan atasan langsung dari jabatan ini.</p>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="nama_unor"
                    label="Unit Organisasi"
                    prepend-inner-icon="mdi-domain"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="atasan"
                    :items="pilihanAtasan"
                    item-text="title"
                    item-value="id"
                    label="Atasan Langsung"
                    placeholder="Pilih atasan langsung"
                    prepend-inner-icon="mdi-account-arrow-up-outline"
                    outlined
                    dense
                    return-object
                    clearable
                    hide-details="auto"
                    class="modern-field"
                    no-data-text="Atasan langsung tidak ditemukan"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <template v-slot:selection="{ item }">
                      <span>{{ item.title }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </section>

            <v-divider class="edit-section-divider" />

            <!-- INFORMASI JABATAN -->
            <section class="edit-section">
              <div class="edit-section-heading">
                <div class="edit-section-icon position-icon">
                  <v-icon>mdi-card-account-details-outline</v-icon>
                </div>

                <div>
                  <h3>Informasi Jabatan</h3>
                  <p>Lengkapi jenis, rumpun, dan identitas jabatan.</p>
                </div>
              </div>

              <v-row dense>
                <!-- JENIS JABATAN -->
                <v-col cols="12" :md="sjj == 'kosong' ? 10 : 8">
                  <v-dialog v-model="Djj" scrollable max-width="650px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="sjj.nama"
                        label="Jenis Jabatan"
                        prepend-inner-icon="mdi-format-list-bulleted-type"
                        outlined
                        dense
                        readonly
                        v-on="on"
                        v-bind="attrs"
                        hide-details="auto"
                        class="modern-field"
                      />
                    </template>

                    <v-form ref="pilihjj">
                      <v-card class="jenis-jabatan-modal">
                        <div class="jenis-jabatan-header">
                          <v-icon color="primary" class="mr-3">
                            mdi-format-list-bulleted-type
                          </v-icon>

                          <div>
                            <h3>Pilih Jenis Jabatan</h3>
                            <p>Pilih kategori dan jenis jabatan yang sesuai.</p>
                          </div>
                        </div>

                        <v-divider />

                        <v-card-text class="pa-5">
                          <v-select
                            outlined
                            dense
                            return-object
                            :items="refjj"
                            @change="cjj"
                            item-key="id"
                            item-text="nama"
                            label="Kategori Jabatan"
                            hide-details="auto"
                            class="modern-field mb-4"
                          />

                          <div class="tree-selection-panel">
                            <v-treeview
                              activatable
                              return-object
                              :items="bawahan"
                              :active.sync="seljj"
                              item-key="id"
                              item-text="nama"
                              item-children="bawahan"
                              selection-type="independent"
                              open-on-click
                              hoverable
                            >
                              <template v-slot:prepend>
                                <v-icon color="primary" small>
                                  mdi-briefcase-outline
                                </v-icon>
                              </template>
                            </v-treeview>
                          </div>
                        </v-card-text>

                        <v-divider />

                        <v-card-actions class="pa-4">
                          <v-btn text color="grey darken-1" @click="clearjj">
                            <v-icon left>mdi-eraser</v-icon>
                            Reset
                          </v-btn>

                          <v-spacer />

                          <v-btn
                            text
                            color="grey darken-1"
                            @click="Djj = false"
                          >
                            Batal
                          </v-btn>

                          <v-btn depressed color="primary" @click="Djj = false">
                            <v-icon left>mdi-check</v-icon>
                            Pilih
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                </v-col>

                <!-- RUMPUN JABATAN -->
                <v-col cols="12" md="4">
                  <v-text-field
                    :value="sjj.kelompok"
                    label="Rumpun Jabatan"
                    prepend-inner-icon="mdi-shape-outline"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <!-- ESELON -->
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    sjj.atasan == 2 ||
                    sjj.id == 25 ||
                    sjj.id == 7 ||
                    sjj.id == 8
                  "
                >
                  <v-autocomplete
                    v-model="SData.eselon.id"
                    :items="refeselon"
                    item-value="id"
                    item-text="nama"
                    label="Eselon"
                    prepend-inner-icon="mdi-sitemap-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <!-- FUNGSIONAL -->
                <v-col
                  cols="12"
                  md="6"
                  v-if="
                    sjj.atasan == 13 ||
                    sjj.atasan == 14 ||
                    sjj.atasan == 19 ||
                    sjj.atasan == 28 ||
                    sjj.atasan == 29 ||
                    sjj.atasan == 34
                  "
                >
                  <v-autocomplete
                    v-model="SData.fungsional.id"
                    :items="reffungsional"
                    item-value="id"
                    item-text="nama"
                    label="Jabatan Fungsional"
                    prepend-inner-icon="mdi-account-tie-outline"
                    outlined
                    dense
                    return-object
                    hide-details="auto"
                    class="modern-field"
                    @change="cfungsional"
                  />
                </v-col>

                <!-- PELAKSANA -->
                <v-col cols="12" md="6" v-if="sjj.atasan == 9 || sjj.id == 9">
                  <v-autocomplete
                    v-model="SData.pelaksana.id"
                    :items="refpelaksana"
                    item-value="id"
                    item-text="nama"
                    label="Jabatan Pelaksana"
                    prepend-inner-icon="mdi-account-hard-hat-outline"
                    outlined
                    dense
                    return-object
                    hide-details="auto"
                    class="modern-field"
                    @change="cpelaksana"
                  />
                </v-col>

                <!-- NAMA JABATAN -->
                <v-col cols="12">
                  <v-text-field
                    v-model="SData.namaJabatan"
                    label="Nama Jabatan"
                    prepend-inner-icon="mdi-text-box-outline"
                    placeholder="Masukkan nama jabatan"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>
              </v-row>
            </section>

            <v-divider class="edit-section-divider" />

            <!-- DETAIL KEBUTUHAN -->
            <section class="edit-section">
              <div class="edit-section-heading">
                <div class="edit-section-icon detail-icon">
                  <v-icon>mdi-clipboard-list-outline</v-icon>
                </div>

                <div>
                  <h3>Detail Jabatan</h3>
                  <p>Atur batas usia, kelas, lokasi, dan kebutuhan pegawai.</p>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="SData.bup"
                    label="Batas Usia Pensiun"
                    prepend-inner-icon="mdi-calendar-clock-outline"
                    type="number"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="SData.kelas_jabatan"
                    :items="refkelasjabatan"
                    item-value="id"
                    item-text="nama"
                    label="Kelas Jabatan"
                    prepend-inner-icon="mdi-layers-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="SData.work_place"
                    :items="refworkplace"
                    item-value="id"
                    item-text="nama"
                    label="Work Place"
                    prepend-inner-icon="mdi-map-marker-outline"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="SData.kebutuhan"
                    label="Kebutuhan Pegawai"
                    prepend-inner-icon="mdi-account-multiple-outline"
                    type="number"
                    outlined
                    dense
                    hide-details="auto"
                    class="modern-field"
                  />
                </v-col>
              </v-row>
            </section>
          </v-card-text>

          <!-- FOOTER -->
          <div class="edit-modal-footer">
            <div class="footer-caption">
              <v-icon small class="mr-1"> mdi-information-outline </v-icon>
              Pastikan data sudah benar sebelum menyimpan.
            </div>

            <div class="footer-actions">
              <v-btn
                text
                color="grey darken-1"
                class="footer-cancel-btn"
                @click="closeModal"
              >
                Batal
              </v-btn>

              <v-btn
                depressed
                color="primary"
                class="footer-save-btn"
                :disabled="!atasan || !atasan.id || !LBtn"
                :loading="!LBtn"
                @click="edit"
              >
                <v-icon left>mdi-content-save-outline</v-icon>
                Simpan Perubahan
              </v-btn>
            </div>
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import "@/assets/styles/pages/anjab/petajab/petajab-edit.css";

import Cookie from "@/helper/cookie.js";
import getRef from "@/helper/getReferensi.js";

// import SView from "@/store/anjab/petajabatan/view";
import SEdit from "@/store/anjab/petajabatan/edit";

export default {
  computed: {
    ModalEdit: {
      get() {
        return SEdit.state.ModalEdit;
      },
      set(value) {
        SEdit.commit("TModal", value);
      },
    },

    SData: {
      get() {
        return SEdit.state.data;
      },

      set(value) {
        console.log(value);
      },
    },

    sjj() {
      if (!this.seljj.length) {
        let data = {
          id: this.SData.janis_jabatan.id,
          nama: this.SData.janis_jabatan.nama,
          atasan: this.SData.janis_jabatan.atasan,
          kelompok: this.SData.janis_jabatan.kelompok,
        };
        return data;
      } else {
        let data = {
          id: this.seljj[0].id,
          nama: this.seljj[0].nama,
          atasan: this.seljj[0].atasan,
          kelompok: this.seljj[0].kelompok,
        };
        return data;
      }
    },
  },

  watch: {
    async ModalEdit(value) {
      if (value) {
        this.refjj = await getRef.new_jj(this.token);
        this.refeselon = await getRef.eselon(this.token);
        this.reffungsional = await getRef.fungsional(this.token);
        this.refpelaksana = await getRef.new_pelaksana(this.token);
        this.refworkplace = await getRef.workplace(this.token);
        this.refkelasjabatan = await getRef.kelasjabatan(this.token);
        this.getData();
      }
    },
  },

  data: () => ({
    token: Cookie.get("token"),
    nama_unor: localStorage.getItem("nama_unor"),
    LBtn: true,

    e1: 1,
    Djj: false,

    refeselon: [],
    refpelaksana: [],
    reffungsional: [],

    refjj: [],
    seljj: [],
    refworkplace: [],
    refkelasjabatan: [],

    bawahan: [],
    dataset: {},

    // atasan: "",

    // Data organisasi dari API
    mapData: [],

    // Pilihan atasan langsung untuk autocomplete
    pilihanAtasan: [],

    // Harus berupa object karena menggunakan return-object
    atasan: {
      id: null,
      title: "",
    },
  }),

  methods: {
    cjj(value) {
      this.bawahan = value.bawahan;
    },

    clearjj() {
      this.$refs.pilihjj.reset();
    },

    cfungsional(value) {
      this.SData.namaJabatan = value.nama;
      this.SData.bup = value.bup;
    },

    cpelaksana(value) {
      this.SData.namaJabatan = value.nama;
      this.SData.bup = value.bup;
    },

    // reset() {
    //   this.refeselon = [];
    //   this.refpelaksana = [];
    //   this.reffungsional = [];

    //   this.dataset = {};

    //   this.atasan = "";
    // },

    convert(value) {
      const files = JSON.stringify(value);
      var parsed = JSON.parse(files, function (k, v) {
        if (k === "namaJabatan") {
          this.title = v;
        } else if (k === "bawahan") {
          this.children = v;
        } else {
          return v;
        }
      });

      return parsed;
    },

    // getData() {
    //   this.ldata = true;
    //   const url = process.env.VUE_APP_API + "anjab/all";
    //   this.axios
    //     .get(url, {
    //       headers: {
    //         Authorization: "Bearer " + this.token,
    //       },
    //     })
    //     .then((res) => {
    //       this.ldata = false;
    //       this.dataset = this.convert(res.data.mapData[0]);
    //     })
    //     .catch((error) => {
    //       console.log(error.response.status);
    //       console.log("Error", error.message);
    //     });
    // },

    pilihatasan(value) {
      this.atasan = value;
      this.e1 = 2;
    },

    // async edit() {
    //   this.LBtn = false;
    //   let data = {
    //     idJab: this.$route.params.id,
    //     parent: this.atasan.id,
    //     namaJabatan: this.SData.namaJabatan,
    //     unor: {
    //       id: this.SData.unor.id,
    //     },
    //     janis_jabatan: {
    //       id: this.sjj.id,
    //     },
    //     eselon: {
    //       id: this.SData.eselon.id,
    //     },
    //     pelaksana: {
    //       id: this.SData.pelaksana.id,
    //     },
    //     fungsional: {
    //       id: this.SData.fungsional.id,
    //     },
    //     bup: this.SData.bup,
    //     work_place: this.SData.work_place,
    //     kelas_jabatan: this.SData.kelas_jabatan,
    //     kebutuhan: this.SData.kebutuhan,
    //   };

    //   const url = process.env.VUE_APP_API + "anjab/edit";
    //   this.axios
    //     .put(url, data, {
    //       headers: {
    //         Authorization: "Bearer " + this.token,
    //       },
    //     })
    //     .then((res) => {
    //       this.LBtn = true;
    //       if (res.data.success) {
    //         SView.commit("refreshData", true);
    //         SView.commit("alert", res.data.message);
    //         SView.commit("berhasilAlert", true);
    //         SView.commit("gagalAlert", false);
    //         SView.commit("success", res.data.success);
    //       } else {
    //         SView.commit("refreshData", true);
    //         SView.commit("alert", res.data.message);
    //         SView.commit("gagalAlert", true);
    //         SView.commit("berhasilAlert", false);
    //         SView.commit("success", res.data.success);
    //       }

    //       this.closeModal();
    //     })
    //     .catch((error) => {
    //       if (error.response.status == 401) {
    //         // Auth.logout();
    //       } else if (error.response) {
    //         SView.commit("refreshData", true);
    //         SView.commit("alert", error.response.data.message);
    //         SView.commit("gagalAlert", true);
    //         SView.commit("berhasilAlert", false);
    //         SView.commit("success", error.response.data.success);
    //         console.log(error.response.status);
    //         this.LBtn = true;
    //         this.closeModal();
    //       } else {
    //         SView.commit("refreshData", true);
    //         SView.commit("alert", error.response.data.message);
    //         SView.commit("gagalAlert", true);
    //         SView.commit("berhasilAlert", false);
    //         SView.commit("success", error.response.data.success);
    //         console.log(error.response.status);
    //         console.log("Error", error.message);
    //         this.LBtn = true;
    //         this.closeModal();
    //       }
    //     });
    // },

    // async closeModal() {
    //   await SView.commit("refreshData", true);
    //   this.reset();
    //   this.e1 = 1;
    //   this.ModalEdit = false;
    // },

    async getData() {
      this.ldata = true;

      const url = `${process.env.VUE_APP_API}/anjab/ref/unor/${this.SData.unor.id}`;

      try {
        const res = await this.axios.get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        });

        this.mapData = Array.isArray(res.data.mapData) ? res.data.mapData : [];

        // Cari atasan langsung dari jabatan yang sedang diedit
        this.cariPilihanAtasan();
      } catch (error) {
        console.error(
          "Gagal mengambil data organisasi:",
          error.response?.data || error.message,
        );

        this.mapData = [];
        this.pilihanAtasan = [];
        this.atasan = { id: null, title: "" };
      } finally {
        this.ldata = false;
      }
    },

    /**
     * Mencari jabatan berdasarkan ID di seluruh tingkatan organisasi.
     */
    cariJabatanById(data, id) {
      if (
        !Array.isArray(data) ||
        id === null ||
        id === undefined ||
        id === ""
      ) {
        return null;
      }

      for (const jabatan of data) {
        if (String(jabatan.id) === String(id)) {
          return jabatan;
        }

        const ditemukan = this.cariJabatanById(jabatan.bawahan || [], id);

        if (ditemukan) {
          return ditemukan;
        }
      }

      return null;
    },

    /**
     * Mencari jabatan yang sedang diedit, lalu mengambil
     * satu tingkat di atasnya sebagai atasan langsung.
     */
    cariPilihanAtasan() {
      const idJabatan = this.$route.params.id;

      this.pilihanAtasan = [];
      this.atasan = {
        id: null,
        title: "",
      };

      if (!idJabatan) {
        console.warn("ID jabatan tidak ditemukan di route.");
        return;
      }

      // Cari jabatan yang sedang diedit
      const jabatan = this.cariJabatanById(this.mapData, idJabatan);

      if (!jabatan) {
        console.warn("Jabatan yang sedang diedit tidak ditemukan:", idJabatan);
        return;
      }

      // Atasan bernilai "0" berarti tidak mempunyai atasan
      if (
        jabatan.atasan === null ||
        jabatan.atasan === undefined ||
        String(jabatan.atasan) === "0" ||
        String(jabatan.atasan) === ""
      ) {
        return;
      }

      // Ambil hanya atasan langsung, bukan semua jabatan
      const parent = this.cariJabatanById(this.mapData, jabatan.atasan);

      if (!parent) {
        console.warn("Atasan langsung tidak ditemukan:", jabatan.atasan);
        return;
      }

      const itemAtasan = {
        id: parent.id,
        title: parent.namaJabatan,
      };

      // Hanya ada satu pilihan: atasan langsung
      this.pilihanAtasan = [itemAtasan];
      this.atasan = itemAtasan;
    },

    /**
     * Lanjut ke langkah kedua jika atasan tersedia.
     */
    lanjutEdit() {
      if (!this.atasan || !this.atasan.id) {
        this.$toast?.error?.("Atasan langsung tidak ditemukan.");
        return;
      }

      this.e1 = 2;
    },

    /**
     * Menutup modal dan membersihkan data pilihan atasan.
     */
    closeModal() {
      this.reset();
      this.e1 = 1;
      this.ModalEdit = false;
    },

    /**
     * Reset data autocomplete dan data organisasi.
     */
    reset() {
      this.mapData = [];
      this.pilihanAtasan = [];

      this.atasan = {
        id: null,
        title: "",
      };
    },

    /**
     * Simpan perubahan jabatan.
     *
     * Pertahankan field payload lain dari method edit() aslimu
     * apabila API membutuhkan field tambahan.
     */
    async edit() {
      if (!this.atasan || !this.atasan.id) {
        console.error("Atasan langsung belum tersedia.");
        return;
      }

      this.LBtn = false;

      const url = `${process.env.VUE_APP_API}/anjab/edit`;

      const payload = {
        idJab: this.$route.params.id,
        parent: this.atasan.id,
        namaJabatan: this.SData.namaJabatan,
        unor: {
          id: this.SData.unor.id,
        },
        janis_jabatan: {
          id: this.sjj.id,
        },
        eselon: {
          id: this.SData.eselon.id,
        },
        pelaksana: {
          id: this.SData.pelaksana.id,
        },
        fungsional: {
          id: this.SData.fungsional.id,
        },
        bup: this.SData.bup,
        work_place: this.SData.work_place,
        kelas_jabatan: this.SData.kelas_jabatan,
        kebutuhan: this.SData.kebutuhan,
      };

      try {
        await this.axios.put(url, payload, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        });

        // Pertahankan commit refresh dan notifikasi dari komponen aslimu.
        this.closeModal();
      } catch (error) {
        console.error(
          "Gagal menyimpan perubahan jabatan:",
          error.response?.data || error.message,
        );
      } finally {
        this.LBtn = true;
      }
    },
  },
};
</script>
